<div class="ai-date-input">
    <input
        type="date"
        [disabled]="disabled()"
        [value]="value()"
        (input)="handleChange($event)"
        (blur)="handleBlur()"
    />
</div>
